var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"header-container",attrs:{"fluid":""}},[_c('header-top-logo',{attrs:{"title":'survey_plan_form.title'}}),_c('div',{staticClass:"spacer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }